import { kitRefusal } from '../../assets/kitErrors';

/** The error line of the confirm dialog (design kit-redo-cover b3), or a refusal with its own path. */
export type CoverRedoError =
  | { kind: 'costChanged'; credits: number }
  | { kind: 'busy' }
  | { kind: 'noMaster' }
  | { kind: 'masterProcessing' }
  | { kind: 'videoCredits' }
  | { kind: 'other' };

function causeOf(error: unknown): Record<string, unknown> | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }
  const cause = (error as { m24Limit?: unknown }).m24Limit;
  return typeof cause === 'object' && cause !== null ? (cause as Record<string, unknown>) : null;
}

/**
 * The refusal of a cover redo call. `customBaseQuery` puts the REST `cause` on the error as
 * `m24Limit`. 409 `M24_COVER_REDO_CONFIRM` carries the cost now in `cause.credits`. Pure.
 */
export function coverRedoError(error: unknown): CoverRedoError {
  const cause = causeOf(error);
  if (cause?.code === 'M24_COVER_REDO_CONFIRM') {
    return { kind: 'costChanged', credits: typeof cause.credits === 'number' ? cause.credits : 0 };
  }
  if ((cause?.reason ?? cause?.code) === 'M24_MASTER_PROCESSING') {
    return { kind: 'masterProcessing' };
  }
  const refusal = kitRefusal(error);
  if (refusal === 'videoCredits' || refusal === 'busy' || refusal === 'noMaster') {
    return { kind: refusal };
  }
  return { kind: 'other' };
}
